import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";

export default class UserCirclesTypeRoute extends DiscourseRoute {
  controllerName = "circles/index";
  templateName = "circles/index";

  queryParams = {
    type: { refreshModel: true, replace: true },
    filter: { refreshModel: true },
  };

  titleToken() {
    const isSelf =
      this.currentUser?.username === this.modelFor("user.circles").username;
    const type = this.modelFor("user.circles.type").type_id;

    const localeKey = isSelf ? type : `${type}-else`;

    return i18n(`discourse_circles.index.user.types.${localeKey}.description`);
  }

  model(params) {
    return params;
  }

  setupController(controller, model) {
    super.setupController(controller, model);

    const { type_id, ...loadParams } = model;
    const user = this.modelFor("user");

    controller.type = null;
    controller.loadCircles({
      ...loadParams,
      type: type_id,
      username: user.username,
    });
  }
}
